<template>
  <v-row>
    <v-col cols="12">
      <div style="min-height: 4px">
        <v-progress-linear
          v-if="isGetEquipesLoading"
          indeterminate
        />
      </div>

      <!-- list filters -->
      <v-card>
        <v-card-title> Filtrar </v-card-title>
        <v-row class="px-2 ma-0">
          <v-col
            cols="12"
            sm="4"
          >
            <VSelect
              v-model="equipeSelecionada"
              :items="equipes"
              item-text="nome"
              item-value="id"
              label="Equipe"
              outlined
              dense
              clearable
              hide-details
              @change="search = false; equipeId = null"
            />
          </v-col>

          <v-spacer></v-spacer>

          <v-col
            cols="12"
            md="2"
            sm="12"
            class="text-right"
          >
            <v-btn
              color="primary"
              @click="filtrar"
            >
              <v-icon>{{ icons.mdiPlus }}</v-icon>
              <span>Filtrar</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-col>

    <v-col
      cols="12"
      md="12"
    >
      <v-row class="match-height">
        <v-col
          v-if="equipeId && search"
          cols="12"
        >
          <v-expand-transition>
            <agentes-situacoes-card
              :agentes-situacoes="agentesSituacoes"
              :loading="isGetAgentesSituacoesLoading"
            />
          </v-expand-transition>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { onMounted, ref } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import { mdiCalendar } from '@mdi/js'
import { select } from '@core/utils/validation'
import AgentesSituacoesCard from '@/views/dashboard/equipe/AgentesSituacoesCard.vue'
import EquipeService from '@/services/modules/EquipeService'
import useUserStore from '@/store/user'
import useRuntimeEquipeAgenteSituacaoNotifications from '@/composables/useRuntimeEquipeAgenteSituacaoNotifications'

export default {
  components: {
    AgentesSituacoesCard,
  },

  setup() {
    const search = ref(false)

    const isGetEquipesLoading = ref(false)
    const equipes = ref([])

    const { id } = storeToRefs(useUserStore())

    async function getEquipes() {
      try {
        isGetEquipesLoading.value = true
        equipes.value = await EquipeService.getEquipesAtivas(id.value)
      } finally {
        isGetEquipesLoading.value = false
      }
    }
    onMounted(getEquipes)

    const equipeSelecionada = ref(null)
    const equipeId = ref(null)

    const { agentesSituacoes, loading: isGetAgentesSituacoesLoading } = useRuntimeEquipeAgenteSituacaoNotifications(equipeId)

    function filtrar() {
      search.value = true
      equipeId.value = equipeSelecionada.value
    }

    return {
      search,
      isGetEquipesLoading,
      equipes,
      equipeSelecionada,
      equipeId,
      agentesSituacoes,
      isGetAgentesSituacoesLoading,
      filtrar,
      icons: { mdiCalendar },
      validators: { select },
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
